const RE_CLEAN = /[^a-z0-9_-]+/ig;

const clean = (str, fallback) => {
    if (str == null) {
        str = fallback;
    } else if (typeof str !== "string") {
        str = "" + str;
    }
    return str.replace(RE_CLEAN, "-");
};

const formatId = (ITid, prefix = "") =>
    clean(prefix, "it-id") +
    "-" +
    clean(ITid, "unspecified");

export default formatId;



// WEBPACK FOOTER //
// ./app/lib/formatId.js